export class ConsentsTranslations {

  constructor(private translations: any) {}

  public getConsentTranslation(consentKey: string, subKey?: string): string {
    if (typeof subKey === 'undefined') {
      return this.translations[consentKey];
    } else {
      if (typeof this.translations[`${consentKey}.${subKey}`] !== 'undefined') {
        return this.translations[`${consentKey}.${subKey}`];
      } else {
        return `${consentKey}.${subKey}`;
      }
    }
  }

  public isReadmoreAvailable(consentKey: string): boolean {
    if (typeof this.translations[`${consentKey}.read_more`] !== 'undefined') {
      return this.translations[`${consentKey}.read_more`] !== '';
    } else {
      return false;
    }
  }
}
